import React from 'react';
import View from 'components/ui/view';
import LoadingSpinner from 'components/ui/loadingSpinner';

export default class AsyncCartPreview extends React.Component {
  state = { Component: null };

  componentDidMount() {
    import('./preview').then(module =>
      this.setState({ Component: module.default })
    );
  }

  render() {
    const { Component } = this.state;
    return Component ? (
      <Component />
    ) : (
      <View padding="lg">
        <LoadingSpinner black />
      </View>
    );
  }
}
